import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=0fc68325&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=0fc68325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc68325",
  null
  
)

export default component.exports